import { Map, fromJS } from 'immutable';

import apiClient from '@sophocles/http-common';
import {
  checkHttpStatus,
  dataTableParamFormatter,
  errorActionWithAlert,
  generateQueryParams,
  mapToQueryParams,
} from '@sophocles/utils';

export function fetchServicesPerformedWithFilters(filterObject) {
  return tableParams => dispatch => {
    const params = Map(filterObject).merge(dataTableParamFormatter(tableParams));
    return apiClient
      .get(`/project/performedservices/?${mapToQueryParams(params)}`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => dispatch(errorActionWithAlert(error, 'REQUEST_JOB_SERVICES_PERFORMED')));
  };
}

export function fetchServicesPerformedForJob(jobId) {
  return dispatch =>
    apiClient
      .get(`/project/performedservices/`, { params: { job: jobId } })
      .then(checkHttpStatus)
      .then(response => response.data)
      .catch(error => dispatch(errorActionWithAlert(error, 'REQUEST_JOB_SERVICES_PERFORMED')));
}

export function fetchTotalsByDateAndSiteGroup(startDate, endDate, textSearch) {
  return dispatch =>
    apiClient
      .get(
        `/project/totals/bydateandsitegroup/?service_date__gte=${startDate}&service_date__lte=${endDate}${textSearch}`,
      )
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => dispatch(errorActionWithAlert(error, 'REQUEST_JOB_SERVICES_TOTALS')));
}

export function fetchRawTotalsByDateAndSiteGroup(filterParams) {
  return dispatch => {
    const params = generateQueryParams(filterParams);
    return apiClient
      .get('/project/totals/bydateandsitegroup/', { params })
      .then(checkHttpStatus)
      .then(response => response.data);
  };
}

export function fetchTotalsByService(filterParams) {
  return dispatch => {
    const params = generateQueryParams(filterParams);
    return apiClient
      .get('/project/totals/byservice/', { params })
      .then(checkHttpStatus)
      .then(response => response.data)
      .catch(error => dispatch(errorActionWithAlert(error, 'REQUEST_JOB_SERVICES_TOTALS')));
  };
}

export function fetchTotalsByCrewService(filterParams) {
  return dispatch => {
    const params = generateQueryParams(filterParams);
    return apiClient
      .get('/project/totals/bycrewandservice/', { params })
      .then(checkHttpStatus)
      .then(response => response.data)
      .catch(error => dispatch(errorActionWithAlert(error, 'REQUEST_JOB_SERVICES_TOTALS')));
  };
}
